import React, { useState } from "react";
import {
Box,
Card,
Typography,
TextField,
Button,
Checkbox,
FormControlLabel,
Snackbar,
Alert,
CircularProgress,
InputAdornment,
IconButton
} from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import { useLocation, useNavigate } from "react-router-dom";
import { adminFetch } from "../services/adminFetch";
import { adminPageSx } from "../utils/adminResponsive";

export default function DeleteAdmin(){

const { state } = useLocation();
const navigate = useNavigate();

const admin = state?.admin;

const [password,setPassword] = useState("");
const [notify,setNotify] = useState(true);
const [loading,setLoading] = useState(false);
const [showPassword,setShowPassword] = useState(false);


const [snackbar,setSnackbar] = useState({
open:false,
message:"",
severity:"success"
});

const showSnackbar = (message,severity="success")=>{
setSnackbar({open:true,message,severity});
};

const handleCloseSnackbar = ()=>{
setSnackbar({...snackbar,open:false});
};




const handleDeleteAdmin = async () => {

if(!password){
showSnackbar("Admin password required","error");
return;
}

setLoading(true);

try{

const data = await adminFetch("/api/admin/delete",{
method:"DELETE",
body: JSON.stringify({
admin_id: admin.id,
password,
notify
})
});

if(!data.status){
showSnackbar(data.message || "Delete failed","error");
setLoading(false);
return;
}

showSnackbar("Admin deleted successfully");

setTimeout(()=>{
navigate("/admin/admins");
},1500);

}catch(err){
console.log(err);
showSnackbar("Server error","error");
}

setLoading(false);
};


return(

<Box sx={{ ...adminPageSx }}>

<Card sx={{ p:{ xs:2, sm:4 }, maxWidth:600, mx:"auto" }}>

<Typography
variant="h5"
fontWeight={700}
sx={{color:"#d32f2f", mb:2}}
>
Delete Admin
</Typography>

<Typography sx={{mb:2}}>
Admin: <b>{admin?.email}</b>
</Typography>

<Typography sx={{mb:2, color:"#d32f2f", fontWeight:600}}>
This action cannot be reversed.
</Typography>

<Typography sx={{mb:2}}>
Deleting this admin will permanently remove their access to the admin panel.
</Typography>

<TextField
label="Enter Your Admin Password"
type={showPassword ? "text" : "password"}
fullWidth
value={password}
onChange={(e)=>setPassword(e.target.value)}
InputProps={{
endAdornment: (
<InputAdornment position="end">
<IconButton onClick={()=>setShowPassword((prev)=>!prev)} edge="end">
{showPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
</IconButton>
</InputAdornment>
)
}}
/>

<FormControlLabel
control={
<Checkbox
checked={notify}
onChange={(e)=>setNotify(e.target.checked)}
/>
}
label={`Notify admin (${admin?.email})`}
/>

<Button
fullWidth
variant="contained"
sx={{
mt:3,
bgcolor:"#d32f2f",
fontWeight:700
}}
onClick={handleDeleteAdmin}
disabled={loading}
>
{loading
? <CircularProgress size={22} sx={{color:"white"}}/>
: "Delete Admin"}
</Button>

</Card>




<Snackbar
open={snackbar.open}
autoHideDuration={4000}
onClose={handleCloseSnackbar}
anchorOrigin={{vertical:"top",horizontal:"center"}}
>
<Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
{snackbar.message}
</Alert>
</Snackbar>

</Box>

);

}
